export default "skymp5-front/b6735c2f8f148062383bf23569867735.png";